const types = {
  SET_INPUT_VALUE: 'AFA_SET_INPUT_VALUE',
  SET_AFA_DETAIL: 'SET_AFA_DETAIL',
  RESET_AFA_DETAIL: 'RESET_AFA_DETAIL',
  SET_ORGANIZATION_AFA_DATA: "SET_ORGANIZATION_AFA_DATA",
  SET_MATTER_AFA_DATA: "SET_MATTER_AFA_DATA"
}

export default types;
